import { Box, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import InputCheckbox from 'component/Input/InputCheckbox';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

/** TRANSLATION*/
import { useTranslation } from 'react-i18next';

/** STYLE */
import useStyles, { AddNewRowTable, HeaderTable } from 'features/setting/default-labs/lab-type/style';

/** API */
import LabTypeApi from 'api/setting/default-labs/lab-type.api';
import LabsApi from 'api/setting/default-labs/lab.api';
import { routeName } from 'routes/routes-name';

import HeaderLabel from 'component/CardCustom/HeaderLabel';
import AutocompleteSelect from 'component/Select/AutocompleteSelect';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { icons } from 'constants/images';
import { colors } from 'constants/theme';
import _ from 'lodash';
import TextInput from 'new-components/inputs/text-input';

interface LabsInterface {
  inputSupport: string
  labId: number
  labName: string
}

interface LabTypesInterface {
  labTypeId: number
  labTypeName: string
  labId: number
  labName: string
  inputSupport: string
}
const initStateErrorMessage = {
  LAB_TYPE_NAME: ``,
  LAB_LIST_NAME: ``
}

export default function FormLabType() {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [labTypeId, setLabTypeId] = useState(Number)
  const [labTypeName, setLabTypeName] = useState('')
  const [labsInit, setLabsInit] = useState<LabsInterface[]>([])
  const [labs, setLabs] = useState<LabsInterface[]>([])
  const [labTypes, setLabTypes] = useState<LabTypesInterface[]>([{ labName: '', labId: 1, inputSupport: 'NOT_SUPPORT', labTypeId: 1, labTypeName: '' }])
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [errorListName, setErrorListName] = useState(false)

  const submit = () => {
    setDisabledSubmit(true)
    const labTypeTemp = labTypes
    const labTypeObject: any = []

    if (!labTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ LAB_TYPE_NAME: t('LAB_TYPE.MESSAGE.LAB_TYPE_NAME') } })
    }
    if (labTypeTemp.length === 0) {
      setDisabledSubmit(false)
      return notiError(t(`กรุณาเลือกรายการ LAB`))
    } else {
      for (const lab of labTypeTemp) {
        if (lab.labName === '') {
          setDisabledSubmit(false)
          setErrorListName(true)
          return setErrorMessage({ ...errorMessage, ...{ LAB_LIST_NAME: t(`กรุณาเลือกรายการ LAB`) } })
        }
        labTypeObject.push({ labName: lab.labName, inputSupport: lab.inputSupport })
      }
    }

    const objCreate = {
      labTypeName: labTypeName,
      status: 'ACTIVE',
      mapLab: labTypeObject
    }

    LabTypeApi.create(objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('LAB_TYPE.MESSAGE.SUCCESS.CREATE'), '', null)
          history.push(routeName.labType)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ LAB_TYPE_NAME: t(`LAB_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ LAB_TYPE_NAME: t(`LAB_TYPE.MESSAGE.${err.message}`) } })
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    const labTypeTemp = labTypes
    const labTypeObject: any = []
    if (!labTypeName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, ...{ LAB_TYPE_NAME: t('LAB_TYPE.MESSAGE.LAB_TYPE_NAME') } })
    }
    if (labTypeTemp.length === 0) {
      setDisabledSubmit(false)
      return notiError(t(`กรุณาเลือกรายการ LAB`))
    } else {
      for (const lab of labTypeTemp) {
        if (lab.labName === '') {
          setDisabledSubmit(false)
          setErrorListName(true)
          return setErrorMessage({ ...errorMessage, ...{ LAB_LIST_NAME: t(`กรุณาเลือกรายการ LAB`) } })
        }
        labTypeObject.push({ labName: lab.labName, inputSupport: lab.inputSupport })
      }
    }

    const objCreate = {
      labTypeName: labTypeName,
      status: 'ACTIVE',
      mapLab: labTypeObject
    }


    LabTypeApi.update(labTypeId, objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t('LAB_TYPE.MESSAGE.SUCCESS.UPDATE'), '', null)
          history.push(routeName.labType)
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ LAB_TYPE_NAME: t(`LAB_TYPE.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ LAB_TYPE_NAME: t(`LAB_TYPE.MESSAGE.${err.message}`) } })
      })
  }
  const loadLabs = useCallback(async () => {
    const res = await LabsApi.findAllActive({})

    if (res.status === 200) {
      const lab: any = []
      for (const data of res.data) {
        lab.push({ labName: data.labName, labId: data.labId, inputSupport: data.inputSupport })
      }
      setLabsInit(lab)
      setLabs(lab)
    }
  }, [])

  const loadLabsEdit = useCallback(async (valueLabTypeId: number) => {
    const res = await LabTypeApi.findLabs(valueLabTypeId)
    const labsNew: any = []
    if (res.status === 200) {
      for (const data of res.data) {
        if (data.mapType !== null) {
          labsNew.push({ labName: data.labName, labId: data.labId, inputSupport: data.inputSupport, labTypeId: valueLabTypeId, labTypeName: '' })
        }
      }
    }
    setLabTypes(labsNew)
  }, [])

  const handleLabType = (labName: any, index: number) => {
    const labTypesTemp: any = [...labTypes]
    if (typeof labName === 'object') {
      labTypesTemp[index].labName = labName.labName
      labTypesTemp[index].labId = labName.labId
      labTypesTemp[index].inputSupport = labName.inputSupport
    } else {
      labTypesTemp[index].labName = labName
      labTypesTemp[index].labId = null
    }
    setLabTypes(labTypesTemp)
  }

  const handleSupportLabType = (checked: boolean, index: number) => {
    const labTypesTemp: any = [...labTypes]
    const check = checked === true ? 'SUPPORT' : 'NOT_SUPPORT'
    labTypesTemp[index].inputSupport = check
    setLabTypes(labTypesTemp)
  }
  const handleDeleteLabType = (index: number) => {
    const labTypesTemp = labTypes.filter((lab: any, iLab: number) => index !== iLab)
    setLabTypes(labTypesTemp)
    setLabs(labsInit)
  }

  const onEdit = (data: any) => {
    setLabTypeName(data.labTypeName)
    setLabTypeId(Number(data.labTypeId))
    loadLabsEdit(Number(data.labTypeId))
  }

  useEffect(() => {
    if (location.state) {
      onEdit(location.state)
    }
    loadLabs()
  }, [loadLabs, location])

  return (
    <Box>
      <HeaderLabel
        text={labTypeId ? t('LAB_TYPE.TITLE_UPDATE') : t('LAB_TYPE.TITLE_CREATE')}
        navigator={{ previousTo: routeName.labType, previousTitle: t('LAB_TYPE.TITLE'), currentTitle: labTypeId ? t('LAB_TYPE.TITLE_UPDATE') : t('LAB_TYPE.TITLE_CREATE') }}
        goBack={routeName.labType}
        onSubmit={labTypeId ? submitEdit : submit}
        disabled={disabledSubmit}
      />
      <Box paddingX="24px">
        <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
          <Grid container>
            <Grid item sm={12} md={4}>
              <TextInput
                value={labTypeName}
                inputProps={{ shrink: true }}
                label={t('LAB_TYPE.INPUT.LAB_TYPE_NAME')}
                onChange={(e) => {
                  setLabTypeName(e.target.value)
                  setErrorMessage(initStateErrorMessage)
                }}
                helperText={errorMessage.LAB_TYPE_NAME}
                required
                fullWidth
              />
            </Grid>
          </Grid>

          <Box width="100%">
            <Typography fontWeight={400} fontSize={16} paddingY="24px">
              {t('LAB_TYPE.TABLE.CELL.LIST_LAB')}
            </Typography>
            <TableContainer component={Paper} style={{ boxShadow: 'none', maxHeight: '100%', overflow: 'auto', scrollbarWidth: 'thin' }}>
              <Table aria-label="simple table" sx={{ tableLayout: 'fixed', minWidth: '600px' }}>
                <TableHead sx={{ backgroundColor: colors.themeMainColor }}>
                  <TableRow>
                    <TableCell key={'#'} align="center" style={{ width: '5%', zIndex: 5, position: 'sticky', top: 0 }}>
                      <HeaderTable color="white">#</HeaderTable>
                    </TableCell>
                    <TableCell key={'list-lab'} align="center" style={{ width: '50%', zIndex: 5, position: 'sticky', top: 0 }}>
                      <HeaderTable color="white">{t('LAB_TYPE.TABLE.CELL.LIST_LAB_NAME')}</HeaderTable>
                    </TableCell>
                    <TableCell key={'lab-remark'} align="center" style={{ width: '25%', zIndex: 5, position: 'sticky', top: 0 }}>
                      <HeaderTable color="white">{t('LAB_TYPE.TABLE.CELL.FILL_ADDITIONAL_INFORMATION')}</HeaderTable>
                    </TableCell>
                    <TableCell key={'lab-action'} align="center" style={{ width: '15%', zIndex: 5, position: 'sticky', top: 0 }}>
                      <HeaderTable color="white">{t('LAB_TYPE.TABLE.CELL.ACTION')}</HeaderTable>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow >
                    <TableCell
                      sx={{
                        borderRight: `1px solid ${colors.black20} !important`, borderLeft: `1px solid ${colors.black20} !important`,
                        cursor: 'pointer',
                        fontSize: '16px',
                        backgroundColor: '',
                        '&:hover': {
                          fontWeight: 600,
                          backgroundColor: `${colors.extraLightGray} !important`,
                        }
                      }}
                      onClick={() => {
                        setLabTypes([{ labName: '', labId: 1, inputSupport: 'NOT_SUPPORT', labTypeId: 1, labTypeName: '' }, ...labTypes])
                      }}
                      colSpan={4}
                    >
                      <AddNewRowTable>+ {t('LAB_TYPE.TABLE.CELL.ADD_LAB_ITEM')}</AddNewRowTable>
                    </TableCell>
                  </TableRow>
                  {labTypes.map((lab: any, index: any) => {
                    return (
                      <TableRow key={`${index}`} sx={{ paddingY: '8px', borderRight: `1px solid ${colors.black20} !important`, borderLeft: `1px solid ${colors.black20} !important`, }}>
                        <TableCell align='center'>{labTypes.length - index}</TableCell>
                        <TableCell>
                          <AutocompleteSelect
                            labelId="grouped-demo"
                            freeSolo
                            disableClearable
                            errMessage={errorListName && !lab?.labName ? errorMessage.LAB_LIST_NAME : ''}
                            options={labs}
                            renderOption={(props, option: any) => (
                              <Box
                                {...props}
                                key={option.value}
                                component="li"
                                sx={{
                                  pointerEvents: _.some(labTypes, { labId: option?.labId }) ? 'none !important' : 'auto !important',
                                  opacity: _.some(labTypes, { labId: option?.labId }) ? .5 : 1
                                }}>
                                {option.labName}
                              </Box>
                            )}
                            getOptionLabel={(option: any) => option.labName || ''}
                            onchange={(e, value) => {
                              handleLabType(value, index)
                              setErrorMessage(initStateErrorMessage)
                            }}
                            inputValue={lab.labName}
                            inputLabel={t('LAB_TYPE.TABLE.CELL.LIST_LAB')}
                            onInputChange={(event, inputLabName) => {
                              if (event != null) {
                                handleLabType(inputLabName, index)
                              }
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <InputCheckbox
                            label={''}
                            checked={lab.inputSupport === 'SUPPORT' ? true : false}
                            onChange={(e) => handleSupportLabType(e.target.checked, index)}

                          />
                        </TableCell>
                        <TableCell align="center">
                          <IconButton
                            className={'btn-delete ml-auto'}
                            aria-label="delete"
                            onClick={(e) => {
                              handleDeleteLabType(index)
                              setErrorMessage(initStateErrorMessage)
                            }}
                            sx={{ backgroundColor: 'transparent !important', padding: 0 }}
                          >
                            <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
